import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import * as PoziApiGml from 'api/gml'
import * as PoziUtils from 'api/utils'
import LoaderHandleGeoJSON, { LoaderFailed } from 'config/LoaderHandleGeoJSON'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

export default function (layerConf) {
  const { titleid } = layerConf

  // console.debug('LoaderGML', titleid, layerConf)

  // Extract URL from config object
  const url = PoziUtils.getLayerUrl(layerConf)

  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (_extent, _resolution, projection, success, failure) {
      // console.debug('LoaderGML - loader', titleid, projection)

      if (!url) {
        console.log('Cannot load GML data without a valid url (layer.config.spatial.url).', titleid)
        return false
      }

      window.store.dispatch(setLayerLoadInProgress(layerConf.titleid))

      PoziApiGml.getDataAsGeoJSON(url)
        .then(function (geojson) {
          LoaderHandleGeoJSON(geojson, projection, geojsonSource, layerConf, success)
        })
        .catch(function (error) {
          console.warn('LoaderGML - unexpected error', titleid, error)

          LoaderFailed(layerConf, 'Unexpected error', failure)
        })
    },
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}
